
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bio/shane-holinde",
      function () {
        return require("private-next-pages/bio/shane-holinde.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bio/shane-holinde"])
      });
    }
  